import { useState } from 'react'
import { Switch } from 'components/UI/Switch/Switch'
import { CompaniesTable } from 'components/Tables/CompaniesTable/CompaniesTable'
import { UnmatchedDoorsTable } from './UnmatchedDoorsTable'
import { StandardSummaryResponse } from 'models/paginated-response'
import { FilterIdentifier } from 'models/saved_view'
import { Category, SubCategory } from 'models/companies'

type UnmatchedChainDoorTableProps = {
  pageParamName: string
  setTotalRowsCount?: (count: StandardSummaryResponse) => void
  tableKey?: string
  category: Category
  subCategory: SubCategory
}

export function UnmatchedChainDoorTable(props: UnmatchedChainDoorTableProps) {
  const { pageParamName, setTotalRowsCount, tableKey, category, subCategory } =
    props

  const UNMATCHED_CHAINS_TABLE_KEY = tableKey
    ? `${tableKey}_CHAINS`
    : 'UNMATCHED_CHAINS_TABLE'
  const UNMATCHED_DOORS_TABLE_KEY = tableKey
    ? `${tableKey}_DOORS`
    : 'UNMATCHED_DOORS_TABLE'

  const [showChainTable, setShowChainTable] = useState(true)

  // Create switch component that both tables will use
  const switchComponent = (
    <Switch
      type={'checkbox'}
      checked={showChainTable}
      onChange={(e) => {
        setShowChainTable(e.target.checked)
      }}
      labelRight={showChainTable ? 'Chain View' : 'Door View'}
      className={'min-w-[120px]'}
    />
  )

  const filterIdentifier = subCategory.id.toString() as FilterIdentifier
  const baseFilters = { unmatched: true }

  return (
    <>
      {showChainTable ? (
        <CompaniesTable
          tableKey={UNMATCHED_CHAINS_TABLE_KEY}
          pageParamName={`${pageParamName}-chain-page`}
          category={category}
          subCategory={subCategory}
          setTotalRowsCount={setTotalRowsCount}
          baseFilters={baseFilters}
          defaultColumnVisibility={{}}
          AfterSearchComponent={switchComponent}
        />
      ) : (
        <UnmatchedDoorsTable
          tableKey={UNMATCHED_DOORS_TABLE_KEY}
          pageParamName={`${pageParamName}-door-page`}
          filterIdentifierModifier={filterIdentifier}
          setTotalRowsCount={setTotalRowsCount}
          useAllDoorProxies={true}
          defaultColumnVisibility={{}}
          AfterSearchComponent={switchComponent}
          subCategory={subCategory}
        />
      )}
    </>
  )
}
